"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDPath = exports.Part = exports.PathPartType = void 0;
var PathPartType;
(function (PathPartType) {
    PathPartType[PathPartType["ROOT"] = 0] = "ROOT";
    PathPartType[PathPartType["CHILD"] = 1] = "CHILD";
    PathPartType[PathPartType["RELATIVE"] = 2] = "RELATIVE";
    PathPartType[PathPartType["CHILD_OR_ID"] = 3] = "CHILD_OR_ID";
})(PathPartType = exports.PathPartType || (exports.PathPartType = {}));
var Part = /** @class */ (function () {
    function Part(type) {
        this.type = type;
    }
    Part.prototype.setKey = function (key) {
        this.key = key;
        return this;
    };
    Part.prototype.setId = function (id) {
        this.id = id;
        return this;
    };
    Part.prototype.setLevel = function (level) {
        this.level = level;
        return this;
    };
    Part.ofChildOrId = function (key, id) {
        return new Part(PathPartType.CHILD_OR_ID).setKey(key).setId(id);
    };
    Part.ofChild = function (key) {
        return new Part(PathPartType.CHILD).setKey(key);
    };
    Part.ofRelative = function (level) {
        return new Part(PathPartType.RELATIVE).setLevel(level);
    };
    Part.ofRoot = function () {
        return new Part(PathPartType.ROOT);
    };
    return Part;
}());
exports.Part = Part;
var TDPath = /** @class */ (function () {
    function TDPath(
    /** The TreeDoc file path or URL, it could absolution or relative */
    docPath) {
        if (docPath === void 0) { docPath = null; }
        this.docPath = docPath;
        /** The path parts */
        this.parts = [];
    }
    TDPath.prototype.addParts = function () {
        var _a;
        var part = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            part[_i] = arguments[_i];
        }
        (_a = this.parts).push.apply(_a, part);
        return this;
    };
    TDPath.parse = function (str) {
        if (typeof str === 'string') {
            if (str.length > 1 && str.endsWith('/'))
                str = str.substring(0, str.length - 1);
            str = str.split('/');
        }
        if (str.length === 0)
            return new TDPath().addParts(Part.ofRelative(0));
        var path = new TDPath();
        for (var _i = 0, str_1 = str; _i < str_1.length; _i++) {
            var s = str_1[_i];
            if ('.' === s)
                path.addParts(Part.ofRelative(0));
            else if ('..' === s)
                path.addParts(Part.ofRelative(1));
            else if (s === '' || s === '#')
                path.addParts(Part.ofRoot());
            else if (s.startsWith('#') && s.length > 0)
                path.addParts(Part.ofChildOrId(s, s.substring(1)));
            else
                path.addParts(Part.ofChild(s));
        }
        return path;
    };
    return TDPath;
}());
exports.TDPath = TDPath;
//# sourceMappingURL=TDPath.js.map